<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <fcc-tabela-botao
          @addField="addField"
          :optionSolicitacoes="optionSolicitacoes"
          @deleteBotao="deleteBotao"
          @editBotao="editBotao"
          :fieldsBotoes="fieldsBotoes"
          @listarTodosBotoes="listarTodosBotoes"
          :lstBotoes="lstBotoes"
          :actions="actions"
        />
        <fccModal
          centered
          idModal="addButtonPadrao"
          size="lg"
          :titleModal="titlePage"
          escondeFooter
          travaEsc
          travaBack
          ><fcc-tabela-botao
            @addField="addField"
            :optionSolicitacoes="[]"
            @deleteBotao="deleteBotao"
            @editBotao="editBotao"
            :fieldsBotoes="fieldsBotoes"
            @listarTodosBotoes="listarTodosBotoes"
            :lstBotoes="lstBotoes"
            :actions="actions"
          />
        </fccModal>
        <fccModal
          centered
          idModal="addFieldButton"
          size="lg"
          titleModal="Lista de botões"
          escondeFooter
          travaEsc
          travaBack
        >
          <form @submit.prevent="botaoFinal.id > 0 ? editarBotao() : salvarBotao()">
            <b-row>
              <b-col><fcc-input v-model="botaoFinal.texto" required>Título botão</fcc-input></b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                ><fcc-input v-model="botaoFinal.tooltip" required>Tooltip botão</fcc-input></b-col
              >
            </b-row>
            <b-row class="mt-3">
              <b-col><fcc-input v-model="botaoFinal.class" required>Classe</fcc-input></b-col>
              <b-col><fcc-input v-model="botaoFinal.cor" required>Cor</fcc-input></b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col cols="3" class="pt-2"
                ><toggle-button v-model="botaoFinal.funcao" :sync="true" /> Chamar Função</b-col
              >
              <b-col cols="3" class="pt-2"
                ><toggle-button v-model="botaoFinal.target" :sync="true" /> Nova aba?</b-col
              >
              <b-col><fcc-input v-model="botaoFinal.icone" required>Icone</fcc-input></b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                ><fcc-input v-model="botaoFinal.url" required>{{
                  botaoFinal.funcao ? 'Nome Função' : 'Url'
                }}</fcc-input></b-col
              >
            </b-row>
            <hr />
            <b-row>
              <b-col cols="3" class="pt-2"
                ><toggle-button v-model="botaoFinal.botaopordata" :sync="true" /> Contém
                data?</b-col
              >
            </b-row>
            <b-row class="mt-3" v-if="botaoFinal.botaopordata">
              <b-col
                ><fccDateInput
                  type="datetime"
                  class="form-control"
                  v-model="botaoFinal.dtinicio"
                  :min-datetime="capturaDataAtualSGP()"
                  required
                >
                  Data inicial
                </fccDateInput></b-col
              >
              <b-col
                ><fccDateInput
                  type="datetime"
                  class="form-control"
                  v-model="botaoFinal.dtfinal"
                  :min-datetime="botaoFinal.dtinicio"
                  required
                >
                  Data final
                </fccDateInput></b-col
              >
            </b-row>
            <hr />
            <b-row class="mt-3">
              <b-col cols="3"
                ><fcc-input v-model="botaoFinal.ordem" required>Ordem</fcc-input></b-col
              >
            </b-row>
            <div class="row innerPage">
              <div class="col-sm-3 ml-auto">
                <fcc-button classeAdd="w-100" tipo="submit">{{ labelsSystem.salvar }}</fcc-button>
              </div>
            </div>
          </form>
        </fccModal>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import FccTabelaBotao from './FccTabelaBotao.vue'

export default {
  components: { FccTabelaBotao },
  data() {
    return {
      botaoFinal: {
        id: 0,
        dtfinal: null,
        dtinicio: null,
        ordem: 0
      },
      itemPorPage: 50,
      sortBy: 'texto',
      titlePage: 'Cadastro de botões',
      lstBotoes: [],
      lstBotoesGeral: [],
      optionSolicitacoes: [
        {
          funcaoButton: 'addField',
          text: 'Adicionar Botão',
          tooltip: 'Adicionar Botão para publicação',
          variant: 'primary',
          icon: 'plus',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ],
      fieldsBotoes: [
        { key: 'id', label: 'ID', sortable: true, active: true },
        { key: 'tooltip', label: 'Título Botão', sortable: true, active: true },
        { key: 'actions', label: '', active: true }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editBotao',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteBotao',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  props: {
    controlePage: {
      type: Object,
      default: null
    }
  },
  methods: {
    addField() {
      this.$root.$emit('bv::show::modal', 'addFieldButton')
    },
    deleteBotao(item) {
      this.callConfirm(this.mensagemExcluir, '').then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C01'))
          axios
            .delete(
              `${store.state.baseUrlPublicacao}PublicacaoConfiguracao/ExcluirBotao/` + item.id,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.filtraAmbiente()
              this.callToast('Botão excluído com sucesso', 'success')
            })
            .catch(this.setErrorSystem)
            .finally(this.carregaTexto)
        }
      })
    },
    vincularBotao(idBotao) {
      const vincula = {
        idPublicacao: this.controlePage.idpublicacao,
        idBotao: idBotao
      }
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          `${store.state.baseUrlPublicacao}PublicacaoConfiguracao/VincularBotaoComPublicacao`,
          vincula,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.filtraAmbiente()
          this.callToast('Botão vinculado com sucesso', 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    editarBotao() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          `${store.state.baseUrlPublicacao}PublicacaoConfiguracao/AlterarBotao`,
          this.botaoFinal,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.filtraAmbiente()
          this.$root.$emit('bv::hide::modal', 'addFieldButton')
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    salvarBotao() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          `${store.state.baseUrlPublicacao}PublicacaoConfiguracao/IncluirBotao`,
          this.botaoFinal,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          const idBotao = response.data
          if (this.controlePage != null) {
            this.vincularBotao(idBotao)
          } else {
            this.filtraAmbiente()
          }
          this.botaoFinal = {
            id: 0,
            dtfinal: null,
            dtinicio: null
          }
          this.$root.$emit('bv::hide::modal', 'addFieldButton')
          this.callToast(this.mensagensUpdate.adicionado, 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    editBotao(item) {
      this.botaoFinal = item
      this.$root.$emit('bv::show::modal', 'addFieldButton')
    },
    listarBotoesPublicacao() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          `${store.state.baseUrlPublicacao}PublicacaoConfiguracao/GetBotaoPorIdPublicacao/${this.controlePage.idpublicacao}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstBotoes = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarTodosBotoes() {
      this.$root.$emit('bv::show::modal', 'addButtonPadrao')
      this.listarBotoesGeral()
    },
    filtraAmbiente() {
      this.controlePage == null ? this.listarBotoesGeral() : this.listarBotoesPublicacao()
    },
    listarBotoesGeral() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .get(
          `${store.state.baseUrlPublicacao}PublicacaoConfiguracao/GetAllBotao`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstBotoes = this.controlePage == null ? response.data : this.lstBotoes
          this.lstBotoesGeral = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  },
  mounted() {
    this.filtraAmbiente()
  }
}
</script>